import { render, staticRenderFns } from "./p&s.vue?vue&type=template&id=150cf418"
import script from "./p&s.vue?vue&type=script&lang=js"
export * from "./p&s.vue?vue&type=script&lang=js"
import style0 from "./p&s.vue?vue&type=style&index=0&id=150cf418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports